import { ImageUploadPage } from "../../image-upload/ImageUploadPage"

export const Upload = () => {
    return (
        <ImageUploadPage />
    )
}